import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlert1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 76,
	height: 76,
	viewBox: "0 0 76 76",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 38C0 17.0132 17.0132 0 38 0V0C58.9868 0 76 17.0132 76 38V38C76 58.9868 58.9868 76 38 76V76C17.0132 76 0 58.9868 0 38V38Z",
			fill: "#FFD9D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 38,
			cy: 38,
			r: 32,
			fill: "#DA1E28"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.2516 24.3179C35.1561 22.6753 36.5914 21.5 38 21.5C39.4087 21.5 40.844 22.6753 40.7484 24.3179L40.0623 42.8448C40.0539 43.3801 39.8376 43.8917 39.4584 44.2709C39.0716 44.6577 38.547 44.875 38 44.875C37.453 44.875 36.9284 44.6577 36.5416 44.2709C36.1624 43.8917 35.9461 43.3801 35.9378 42.8448L35.2516 24.3179ZM38.027 24.2703C38.027 24.2703 38.0269 24.2702 38.0266 24.2699C38.0269 24.2702 38.027 24.2703 38.027 24.2703ZM37.973 24.2703C37.973 24.2703 37.9731 24.2702 37.9734 24.2699C37.9732 24.2702 37.973 24.2703 37.973 24.2703Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.25 51.75C35.25 50.2312 36.4812 49 38 49C39.5188 49 40.75 50.2312 40.75 51.75C40.75 53.2688 39.5188 54.5 38 54.5C36.4812 54.5 35.25 53.2688 35.25 51.75Z",
			fill: "white"
		})
	]
});
export default SvgAlert1;
